import GetSafetyHookLookupRequestModel from '../../../generated/types/model/request/GetSafetyHookLookupRequestModel';

export default class GetSafetyHookLookupRequestViewModel extends GetSafetyHookLookupRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
